@if (comment) {
  <p-card class="p-fluid w-full">
    <ng-template pTemplate="content">
        <textarea class="w-full" [disabled]="!isNew()" pInputTextarea [(ngModel)]="comment.comment" required autofocus></textarea>
        <p class="pt-4">{{comment.authorRole}}: {{comment.authorScreenName}}</p>
        @if (submitted && (!comment.comment || comment.comment.length === 0)) {
          <small class="ng-dirty ng-invalid">You need to leave a comment.</small>
        }
      @if (comment.replies?.length > 0) {
        <p-accordion [multiple]="true" [activeIndex]="[comment.replies?.length-1]" (onOpen)="Reply.markViewed(comment.replies[$event.index],user())">
          @for (reply of comment.replies; track reply) {
            <p-accordionTab [header]="reply.authorRole+': '+reply.authorScreenName">
              <p class="m-0">
                {{ reply.comment }}
              </p>
            </p-accordionTab>
          }
        </p-accordion>
      }
      @if (!isNew()) {
        <div class="field">
          <textarea class="w-full" pInputTextarea [(ngModel)]="baseReply.comment" required autofocus></textarea>
          <p class="pt-4">Reply</p>
          @if (submitted && (!baseReply.comment || baseReply.comment.length === 0)) {
            <small class="ng-dirty ng-invalid">You have to write a reply</small>
          }
        </div>
      }
      <!--
      Reply goes here if it isn't a new comment.
      Note: We don't allow editing of comments once they are saved.
      -->
    </ng-template>
  </p-card>
}
